import { render, staticRenderFns } from "./delete_bis.vue?vue&type=template&id=35190a34"
import script from "./delete_bis.vue?vue&type=script&lang=ts"
export * from "./delete_bis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports